import type { en } from "./en.ts";

export const fr: typeof en = {
    Feedback: {
        sentiment: {
            positive: "Positif",
            constructive: "Constructif",
            neutral: "Neutre"
        },
        metric: {
            recognition: "Reconnaissance",
            feedback: "Feedback",
            relationshipWithPeers: "Relation avec les pairs",
            relationshipWithManager: "Relation avec le gestionnaire",
            satisfaction: "Satisfaction",
            alignment: "Alignement",
            happiness: "Bonheur",
            wellness: "Bien-être",
            personalGrowth: "Croissance personnelle",
            ambassadorship: "Sentiment d'appartenance"
        },
        source: {
            officevibe: "Sondage éclair : questions Officevibe",
            custom: "Sondage éclair : questions personnalisées",
            onboarding: "Sondage d'intégration",
            smart: "Questions intelligentes",
            nonSurvey: "Hors sondage"
        },
        date: {
            week: "Semaine du {{date}}",
            absolute: "{{date}}"
        },
        status: {
            replied: "Répondu"
        },
        outboxSender: {
            you: "Vous",
            anonymous: "Vous (anonyme)"
        }
    },
    SuggestionComposeDialog: {
        title: "Donner du feedback",
        close: "Fermer",
        liveRegion: {
            limitReached: "Limite de caractères atteinte."
        },
        recipient: {
            label: "À",
            name: "Boîte à suggestions",
            subtitleAnonymous: "Anonyme, partagé avec la direction",
            subtitleIdentified: "Partagé avec la direction"
        },
        message: {
            label: "Quel est votre feedback ?",
            placeholder: "Partagez ce que vous avez en tête. Soyez précis sur ce qui s'est passé et sur ce qui vous aiderait.",
            charactersLeft_one: "{{count}} caractère restant",
            charactersLeft_other: "{{count}} caractères restants"
        },
        identity: {
            label: "Comment envoyer ce feedback",
            selfLabel: "Envoyer en votre nom",
            selfDescription: "La direction verra votre nom avec ce feedback.",
            anonymousLabel: "Envoyer anonymement",
            anonymousDescription: "La direction ne saura pas qui l'a envoyé."
        },
        footer: {
            anonymous: "Envoi anonyme",
            from: "De {{name}}"
        },
        cancel: "Annuler",
        submit: "Envoyer le feedback",
        discardChangesTitle: "Abandonner ce feedback ?",
        discardChangesBody: "Vous n'avez pas encore envoyé ceci. Quitter maintenant fera perdre ce que vous avez écrit.",
        discardChangesConfirmLabel: "Abandonner",
        discardChangesCancelLabel: "Continuer à modifier",
        successToast: "Feedback envoyé",
        errorToast: "Impossible d'envoyer votre feedback. Veuillez réessayer."
    }
};
